import { IBannerRequest } from '../../interfaces/Website/Banners/IBanners'
import apiService from '../Api'

export default class BannerService {
  async list() {
    return apiService.get('internal/website/banner').then(({ data }) => data)
  }

  async create(data: IBannerRequest) {
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      if ((data as Record<string, string | File>)[key]) {
        formData.append(key, (data as Record<string, string | File>)[key])
      }
    })

    return apiService
      .post('internal/website/banner', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => data)
  }

  async update(id: number, data: IBannerRequest) {
    const formData = new FormData()
    formData.append('_method', 'PUT')
    Object.keys(data).forEach((key) => {
      if ((data as Record<string, string | File>)[key]) {
        formData.append(key, (data as Record<string, string | File>)[key])
      }
    })

    return apiService
      .post(`internal/website/banner/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => data)
  }

  async reorder(order: number[]) {
    return apiService.put('internal/website/banner/reorder', { order }).then(({ data }) => data)
  }

  async delete(id: number) {
    return apiService.delete(`internal/website/banner/${id}`).then(({ data }) => data)
  }

  async enable(id: number) {
    return apiService.put(`internal/website/banner/enable/${id}`).then(({ data }) => data)
  }

  async disable(id: number) {
    return apiService.put(`internal/website/banner/disable/${id}`).then(({ data }) => data)
  }
}
